import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal/index';
import ModalBody from '../Modal/ModalBody';
import ModalFooter from '../Modal/ModalFooter';
import ModalHeader from '../Modal/ModalHeader';
import styles from '../Modal/styles.module.css';
import {
  trackEvent,
  CLICKED_NURTURE_BAR_POPUP,
  NURTURE_BAR_TYPES,
} from '../../util/segment';
import { PRODUCT_PLANS_PAGE_URL } from './nurture-content';

const FreemiumModal = (props) => {
  const closeBtn = (event, message) => {
    trackEvent(CLICKED_NURTURE_BAR_POPUP, {
      nurtureBarType: NURTURE_BAR_TYPES.freemium,
      notificationType: props.segmentNotificationType,
      ctaType: 'close',
      message,
    });
    props.closeModal();
  };

  const goToPricingPlansPage = async (event) => {
    event.preventDefault();
    await trackEvent(CLICKED_NURTURE_BAR_POPUP, {
      nurtureBarType: NURTURE_BAR_TYPES.freemium,
      notificationType: props.segmentNotificationType,
      message: props.btnCaption,
      ctaType: 'upgrade'
    });
    props.closeModal();
    window.location.href = PRODUCT_PLANS_PAGE_URL;
  };

  return (
    <Modal
      namespace={props.namespace}
      width={props.width}
      showModal={props.showModalFlag}
      backgroundColor={props.backgroundColor}
    >
      <ModalHeader closeBtn={event => closeBtn(event, 'X')}>
        {props.title}
      </ModalHeader>
      <ModalBody>
        {props.body}
      </ModalBody>
      <ModalFooter>
        {
          props.btnCaption !== ''
          && (
            <div>
              <a
                role="button"
                className={styles.freemiumNurtureModalContentUpgradeBtn}
                onClick={goToPricingPlansPage}
                href={PRODUCT_PLANS_PAGE_URL}
              >
                {props.btnCaption}
              </a>
              <br />
              <button
                type="button"
                className={styles.nurtureModalContentDismissBtn}
                onClick={event => closeBtn(event, 'Dismiss')}
              >
                Dismiss
              </button>
            </div>
          )
        }
      </ModalFooter>
    </Modal>
  );
};

export default FreemiumModal;

FreemiumModal.propTypes = {
  width: PropTypes.string.isRequired,
  namespace: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  btnCaption: PropTypes.string.isRequired,
  showModalFlag: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  segmentNotificationType: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
};
